import { SupportedCountriesDataType } from "pages/employer-of-record/contexts/supportedCountriesContext";

export const getSortedCountries = (
  countryList: SupportedCountriesDataType[],
  memberByCountryCount: { [key: string]: number }
): SupportedCountriesDataType[] => {
  // Sort countries alphabetically A-Z by commonName and push countries without members to the bottom
  return countryList.sort((lhs, rhs) => {
    const memberCountA = memberByCountryCount[lhs.code] ?? 0;
    const memberCountB = memberByCountryCount[rhs.code] ?? 0;

    // If one country has members and the other doesn't, push the one without members to the bottom
    if (memberCountA === 0 && memberCountB !== 0) {
      return 1;
    }
    if (memberCountB === 0 && memberCountA !== 0) {
      return -1;
    }
    const countryNameA = lhs.commonName || "";
    const countryNameB = rhs.commonName || "";
    return countryNameA.localeCompare(countryNameB);
  });
};
